// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1TOFp","left":"InfoRow_left__qPYUj"};